<form class="form-vertical" id="editexamtemplateform" data-hook="editexamtemplateform">


  <!-- Template Editor Main -->
  <div class="form-group myform">
    <label>Kürzel/Typ
      <input type="text" ng-model="vm.examtemplate.template.type" class="form-control"
             ng-blur="vm.examtemplate.$save()" placeholder="Kürzel/Typ"></label>
  </div>
  <div class="form-group myform">
    <label>Vollständige Bezeichnung
      <input type="text" ng-model="vm.examtemplate.template.displayname" class="form-control"
             ng-blur="vm.examtemplate.$save()" placeholder="Vollständige Bezeichnung"></label>
  </div>
  <div class="form-group myform">
    <label>Quellenangabe
      <input type="text" ng-model="vm.examtemplate.template.sources" class="form-control"
             ng-blur="vm.examtemplate.$save()"
             placeholder="y.B. Deutsche Herzgesellschaft, Lehrbuch der Endoskopie ..."></label>
  </div>
  <div class="form-group">
    <label>Befundinhalte in Gesamtbefund inkludieren
      <div class="radio">
        <label for="tinc1" class="radio-inline"><input type="radio" ng-value="true"
                                                       ng-model="vm.examtemplate.template.includefindings"
                                                       id="tinc1">Ja</label>
        <label for="tinc2" class="radio-inline"><input type="radio" ng-value="false"
                                                       ng-model="vm.examtemplate.template.includefindings"
                                                       id="tinc2">Nein</label>
      </div>
    </label>
  </div>


  <!--  Networkgrabber  -->
  <div class="form-group">
    <label>Bilder/Dateien von Netzwerklaufwerk einbeziehen
      <div class="radio">
        <label for="tnet1" class="radio-inline"><input type="radio" ng-value="true"
                                                       ng-model="vm.examtemplate.template.loadfiles"
                                                       id="tnet1">Ja</label>
        <label for="tnet2" class="radio-inline"><input type="radio" ng-value="false"
                                                       ng-model="vm.examtemplate.template.loadfiles"
                                                       id="tnet2">Nein</label>
      </div>
    </label>
  </div>

  <div class="form-group" ng-show="vm.examtemplate.template.loadfiles === true">
    <label for="tname">Netzwerklaufwerk</label>
    <select ng-model="vm.examtemplate.template.shareid" class="form-control" id="tname">
      <option ng-repeat="share in vm.allshares" value="{{share._id}}">{{share.name}}</option>
    </select>
  </div>

  <div class="alert alert-warning" ng-show="vm.shareserror" ng-bind="vm.gdtperror"></div>


  <!--  DICOM Configuration   -->

  <div class="form-group">
    <label>DICOM Untersuchung
      <div class="radio">
        <label for="isdicom1" class="radio-inline"><input type="radio" ng-value="true"
                                                          ng-model="vm.examtemplate.template.isdicom"
                                                          id="isdicom1">Ja</label>
        <label for="isdicom2" class="radio-inline"><input type="radio" ng-value="false"
                                                          ng-model="vm.examtemplate.template.isdicom"
                                                          id="isdicom2">Nein</label>
      </div>
    </label>
  </div>


  <div class="form-group" ng-show="vm.examtemplate.template.isdicom === true">
    <label for="dicommodalitytype">DICOM Modality Type</label>
    <select ng-model="vm.examtemplate.template.dicommodalitytype" class="form-control" id="dicommodalitytype">
      <option ng-repeat="mod in vm.modalitypes" value="{{mod.type}}">{{mod.text}}</option>
    </select>
  </div>

  <div class="form-group" ng-show="vm.examtemplate.template.isdicom === true">
    <label for="dicommodalityae">DICOM Modality AE Title</label>
    <select ng-model="vm.examtemplate.template.dicommodalityaetitle" class="form-control" id="dicommodalityae">
      <option ng-repeat="modname in vm.dicomaetitle.dicomaetitle" value="{{modname}}">{{modname}}</option>
    </select>

    <div class="alert alert-warning" ng-show="vm.dicomerror" ng-bind="vm.dicomerror"></div>
  </div>

  <!-- GDT Configuration -->
  <div class="form-group">
    <label>GDT Untersuchung
      <div class="radio">
        <label for="isdicom1" class="radio-inline"><input type="radio" ng-value="true"
                                                          ng-model="vm.examtemplate.template.isgdt"
                                                          id="isgdt1">Ja</label>
        <label for="isdicom2" class="radio-inline"><input type="radio" ng-value="false"
                                                          ng-model="vm.examtemplate.template.isgdt"
                                                          id="isgdt2">Nein</label>
      </div>
    </label>
  </div>

  <div class="form-group" ng-show="vm.examtemplate.template.isgdt === true">
    <label for="gdtsw">GDT Software Share</label>
    <select ng-model="vm.examtemplate.template.gdtsoftwareshareid" class="form-control" id="gdtsw">
      <option ng-repeat="share in vm.gdtshares " value="{{share._id}}${{share.name}}">{{share.name}}</option>
    </select>
  </div>
  <div class="alert alert-warning" ng-show="vm.gdtswerror" ng-bind="vm.gdtperror"></div>

  <div class="form-group" ng-show="vm.examtemplate.template.isgdt === true">
    <label for="dicommodalityae">GDT Profil</label>
    <select ng-model="vm.examtemplate.template.gdtprofil" class="form-control" id="gdtprofil">
      <option ng-repeat="profil in vm.gdtprofil.gdtprofil" value="{{profil}}">{{profil}}</option>
    </select>

    <div class="alert alert-warning" ng-show="vm.gdtperror" ng-bind="vm.gdtperror"></div>
  </div>

  <!--  Template Layout   -->
  <div class="form-group">
    <!-- TODO: add layout help pdf-->
    <label>Vorlagenlayout
      <sprhelp tip="Vorlagenlayout" descref="vm.sprlayout" file="templatelayouthelp.pdf"></sprhelp>
      <div class="radio">
        <label for="tinc1" class="radio-inline"><input type="radio" value="col"
                                                       ng-model="vm.examtemplate.template.layout"
                                                       id="layout1">Spaltenorientiert</label>
        <label for="tinc2" class="radio-inline"><input type="radio" value="row"
                                                       ng-model="vm.examtemplate.template.layout"
                                                       id="layout2">Zeilenorientiert</label>
      </div>
    </label>
  </div>


  <div>
    <h4>Feldgruppen</h4>
    <a class="btn btn-success"
       ng-click="vm.newFieldGroup()"
       style="margin-right: 8px;">
      <i class="fa fa-plus"></i> Neue Kategorie/Feldgruppe hinzuf&uuml;gen
    </a>
  </div>

  <div class="clear: both"></div>
  <!-- main exameditor tree -->
  <div ui-tree class="mtree" data-drag-delay="100" data-max-depth="2">
    <ol ui-tree-nodes="" ng-model="vm.examtemplate.template.fieldgroups">
      <li ui-tree-node ng-repeat="fieldgroup in vm.examtemplate.template.fieldgroups" data-drag-delay="100"
          data-expand-on-hover="500">
        <div class="tree-node tree-node-content" data-drag-delay="100">
          <!-- Fieldgroup title, edit title -->
          <span class="pull-left">
                        <a class="btn btn-success btn-xs" style="margin-left: 8px"
                           ng-if="fieldgroup.fields && fieldgroup.fields.length > 0"
                           data-nodrag ng-click="toggle(this)">
                            <i class="fa"
                               ng-class="{'fa-chevron-up': collapsed, 'fa-chevron-down': !collapsed }"></i>
                        </a>
            <!-- TODO: make nicer version of label editing -->
            <!-- prepared fieldgroupnamewidget and functions, but ui-tree can't easily access callerscope -->
            <!--                    <span ng-hide="fieldgroup.label == ''">
                                    {{fieldgroup.label}}&nbsp;
                                    <span class="btn btn-primary btn-xs" uib-tooltip="Kategorie/Feldgruppe umbennen" ng-click="$parent.$parent.$parent.$parent.vm.showFGN($index)">
                                        <i class="fa fa-pencil"></i>
                                    </span>
                                    <span class="btn btn-primary btn-xs" uib-tooltip="Alle Felder in &laquo;Felder ohne Kategorie&raquo; umwandeln"
                                          ng-click="fieldgroup.label = ''">
                                        <i class="fa fa-chevron-left"></i><i class="fa fa-outdent"></i>
                                    </span>
                                </span>
                                <span ng-show="fieldgroup.label == ''">
                                    Felder ohne Gruppe&nbsp;
                                    <span class="btn btn-primary btn-xs" uib-tooltip="Alle Felder zu &laquo;Feldern in einer Kategorie&raquo; umwandeln">
                                        <i class="fa fa-chevron-right" ng-click="$parent.$parent.$parent.$parent.$parent.vm.showFGN($index)"></i><i class="fa fa-indent"></i>
                                    </span>
                                </span>-->

            <!--<fieldgroupname ng-show="$parent.$parent.$parent.$parent.vm.fgnshow[$index]" fgname="fieldgroup.label" ondone="$parent.$parent.$parent.$parent.vm.hideFGN($index)"></fieldgroupname>-->
            <!--                    <input type="text" data-nodrag
                                       ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }"
                                       class="form-control small-input"
                                       ng-model="fieldgroup.label"/>-->
                        <span ng-hide="fieldgroup.label === ''">
                            {{fieldgroup.label}}
                            <input type="text" data-nodrag
                                   ng-model-options="{ updateOn: 'blur default', debounce: { default: 500, blur: 0 } }"
                                   class="form-control small-input"
                                   ng-model="fieldgroup.label">
                        </span>
                        <span ng-show="fieldgroup.label === ''">Felder ohne Gruppe
                          <input type="text" class="form-control small-input" ng-model="fieldgroup.label"
                                 ng-model-options="{ updateOn: 'blur default', debounce: { default: 500, blur: 0 } }"
                                 data-nodrag
                                 uib-tooltip="Leer lassen damit Felder direkt ohne Feldgruppe erscheinen">
                        </span>
                    </span>
          <!-- Fieldgroup action buttons -->
          <span class="pull-right">
                        <!-- add field to fieldgroup -->
                        <a class="btn btn-success btn-xs"
                           uib-tooltip="Neues Feld in diese Gruppe einfügen"
                           data-nodrag ng-click="vm.newSubItem(this)"
                           style="margin-right: 8px;">
                            <i class="fa fa-plus"></i>
                        </a>
            <!-- delete fieldgroup -->
                        <a class="btn btn-danger btn-xs"
                           uib-tooltip="Feldgruppe Löschen"
                           data-nodrag
                           ng-really-click="vm.remove(this)"
                           ng-really-message="Wollen Sie diese Kategorie/Feldgruppe wirklich l&ouml;schen? Diese &Auml;nderung kann nicht r&uuml;ckg&auml;ngig gemacht werden!"
                        >
                            <i class="fa fa-remove"></i>
                        </a>
            <!-- drag handle -->
                        <a class="btn btn-info btn-xs" style="margin-right: 8px;"
                           uib-tooltip="Ziehen um die Gruppen umzusortieren"
                           ui-tree-handle>
                            <i class="fa fa-bars"></i>
                        </a>
                    </span>
          <span class="clearfix"></span>
        </div>
        <!-- render fields of fieldgroup using custom template included below -->
        <ol ui-tree-nodes="" ng-model="fieldgroup.fields" ng-class="{'hidden': !collapsed}">
          <li ui-tree-node
              ng-repeat="field in fieldgroup.fields"
              ng-include="'field_renderer.html'">
            <div ui-tree-handle>
              {{field.label}}
            </div>
        </ol>
      </li>
      <!-- ui-tree-node -->
    </ol>
    <!-- ui-tree-nodes -->
  </div>
  <!-- ui-tree -->

<!--  Spezialfelder: Biopsie, Kommentar, Diagnose/Zusammenfassung, Emfehlung/Therapie-->
  <div ng-hide="vm.examtemplate.template.includefindings" class="spacer-bottom spacer-top">
    <h4>Zusatzfelder</h4>
    <!-- pseduo tree for named fields -->
    <div ui-tree data-nodrop-enabled="true" data-drag-enabled="false" class="mtree">
      <ol ui-tree-nodes="" ng-model="vm.examtemplate.template" data-nodrop-enabled="true"
          data-drag-enabled="false">
        <li ui-tree-node ng-model="vm.examtemplate.template.biopsy"
            ng-if="vm.examtemplate.template.biopsy"
            data-drag-enabled="false"
            ng-include="'biopsy_renderer.html'">
          <div ui-tree-handle>
            {{vm.examtemplate.template.biopsy.label}}
          </div>
        </li>
        <li ui-tree-node ng-model="vm.examtemplate.template.comment"
            ng-if="vm.examtemplate.template.comment"
            data-drag-enabled="false"
            ng-include="'comment_renderer.html'">
          <div ui-tree-handle>
            {{vm.examtemplate.template.comment.label}}
          </div>
        </li>
        <li ui-tree-node
            ng-model="vm.examtemplate.template.diagnosis"
            ng-if="vm.examtemplate.template.diagnosis"
            data-drag-enabled="false"
            ng-include="'diagnosis_renderer.html'">
          <div ui-tree-handle>
            {{vm.examtemplate.template.diagnosis.label}}
          </div>
        </li>
        <li ui-tree-node ng-model="vm.examtemplate.template.recommendation"
            ng-if="vm.examtemplate.template.recommendation"
            data-drag-enabled="false"
            ng-include="'recommendation_renderer.html'">
          <div ui-tree-handle>
            {{vm.examtemplate.template.recommendation.label}}
          </div>
        </li>
      </ol>
      <div class="spacer-top spacer-bottom">
        <div ng-hide="vm.examtemplate.template.biopsy"
             class="btn btn-success"
             ng-click="vm.addNamedField('biopsy')">Biopsiefeld hinzufügen
        </div>

        <div ng-hide="vm.examtemplate.template.diagnosis"
             class="btn btn-success"
             ng-click="vm.addNamedField('diagnosis')">Diagnose-/Zusammenfassungsfeld hinzufügen
        </div>
        <div ng-hide="vm.examtemplate.template.recommendation"
             class="btn btn-success"
             ng-click="vm.addNamedField('recommendation')">(Therapie-) Empfehlungsfeld hinzufügen
        </div>
        <div ng-hide="vm.examtemplate.template.comment"
             class="btn btn-success"
             ng-click="vm.addNamedField('comment')">Kommentarfeld hinzufügen
        </div>
      </div>
    </div>
  </div>

  <!-- Default Services for exam-->
  <div class="row spacer-top spacer-bottom">
    <div class="col-xs-12">

      <div class="panel panel-default">
        <div class="panel-heading"><h4>Rechnungspositionen für diese Untersuchung</h4></div>
        <div class="panel-body">
          <div class="alert alert-info spacer-top spacer-bottom">Wenn Sie Leistungspositionen und/oder Leistungsgruppen mit dieser Untersuchungsvorlage verknüpfen,
            werden die Leistungspositionen/-gruppen beim Start der Untersuchung automatisch zur Rechnung hinzugefügt.</div>
          <label>Suche nach Leistungsositionen</label>
          <privcatsearch onselectcb="vm.addCatItem(privcat, privcatref)" editinplace="false"
                         privcat="" privcatref=""
                         hideaddoption="true"></privcatsearch>
          <label>Leistungsgruppen hinzufügen</label>
          <privcatgroupchooser onselectcb="vm.addCatGroup(privcat, privcatref)"></privcatgroupchooser>
          <div ng-show="vm.examtemplate.template.services.items.length">
            <label>Gewählte Leistungen</label>
            <ul>
              <li ng-repeat="item in vm.examtemplate.template.services.items">
                <span class="pull-left">{{item.name}}</span>
                <span class="pull-right btn btn-danger btn-xs" ng-click="vm.removeCatItem($index)">
                        <i class="fa fa-remove"></i>
                    </span>
                <span class="clearfix"></span>
              </li>
            </ul>
          </div>
          <div ng-show="vm.examtemplate.template.services.groups.length">
            <label>Gewählte Leistungsgruppen</label>
            <ul>
              <li ng-repeat="item in vm.examtemplate.template.services.groups">
                <span class="pull-left">{{item.name}}</span>
                <span class="pull-right btn btn-danger btn-xs" ng-click="vm.removeCatGroup($index)">
                        <i class="fa fa-remove"></i>
                    </span>
                <span class="clearfix"></span>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>


  <!-- Tracker fields for exam-->
  <div class="row spacer-top spacer-bottom">
    <div class="col-xs-12">
      <div class="panel panel-default">
        <div class="panel-heading"><h4>Tracker Dateneingabe für diese Untersuchung</h4></div>
        <div class="panel-body">
          <div class="alert alert-info spacer-top spacer-bottom">Wenn Sie einen Tracker mit dieser Untersuchungsvorlage verknüpfen,
            erscheint das Tracker Eingabefeld im Untersuchungsformular.
            Der aktuelle Wert wird in der Untersuchung gespeichert und ausgegeben und erscheint zusätzlich im Tracker.</div>
          <label>Tracker hinzufügen</label>
          <trackerchooser onselectcb="vm.addTracker(tracker)"></trackerchooser>
          <div ng-show="vm.examtemplate.template.trackers.length" class="spacer-top">
            <label>Gewählte Tracker</label>
            <ul>
              <li ng-repeat="tracker in vm.examtemplate.template.trackers">
                <span class="pull-left">{{tracker.name}}</span>
                <span class="pull-right btn btn-danger btn-xs" ng-click="vm.removeTracker($index)">
                          <i class="fa fa-remove"></i>
                        </span>
                <span class="clearfix"></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Speichern, Abbrechen -->
  <div class="row spacer-top">
    <div class="col-xs-12">
      <div class="form-group">
        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>
        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>
      </div>
    </div>
  </div>
</form>


<!-- ######################################################################################## -->
<!-- Inline Templates                                                                         -->
<!-- ######################################################################################## -->

<!-- Nested field render template -->
<script type="text/ng-template" id="field_renderer.html">
  <div class="tree-node tree-node-content">
    <div style="margin: 8px">
      <div>
                <span class="pull-left">
                    <a class="btn btn-success btn-xs"
                       uib-tooltip="Feld editieren"
                       data-nodrag ng-click="ecollapsed=!ecollapsed">
                        <i class="fa fa-chevron-down" ng-show="ecollapsed"></i>
                        <i class="fa fa-chevron-up" ng-hide="ecollapsed"></i>
                    </a>
                    {{field.label}}</span>
        <span class="pull-right">
                    <!-- edit -->
                    <a class="btn btn-primary btn-xs"
                       uib-tooltip="Feld editieren"
                       data-nodrag ng-click="ecollapsed=!ecollapsed"
                       style="margin-right: 8px;">
                        <i class="fa fa-edit"></i>
                    </a>
          <!-- remove -->
                    <a class="btn btn-danger btn-xs"
                       uib-tooltip="Feld entfernen"
                       data-nodrag ng-really-click="vm.remove(this)"
                       ng-really-message="Wollen Sie dieses Feld wirklich l&ouml;schen? Diese &Auml;nderung kann nicht r&uuml;ckg&auml;ngig gemacht werden!">
                        <i class="fa fa-remove"></i>
                    </a>
          <!-- drag handle -->
                    <a class="btn btn-info btn-xs"
                       uib-tooltip="Ziehen um die Gruppen umzusortieren"
                       ui-tree-handle>
                        <i class="fa fa-bars"></i>
                    </a>
                </span>
        <span class="clearfix"></span>


        <div id="meta{{$index}}" ng-class="{'hidden':ecollapsed}" ng-init="ecollapsed = true">
          <div class="form-group">
            <label>Feldname
              <input type="text" ng-model="field.label" class="form-control" data-nodrag></label>
          </div>
          <div class="form-group">
            <label uib-tooltip="Wird automatisch in der Vorlage vorausgefüllt">Standardwert(e)
              <tags-input ng-model="field.avalues" data-nodrag
                          display-property="name"
                          add-on-comma="false"
                          enableEditingLastTag="true"
                          placeholder="Neuer Eintrag <Eingabetaste>"
                          replace-spaces-with-dashes="false"
                          template="tag-template">
              </tags-input>
            </label>
          </div>
          <div class="form-group">
            <label>Mögliche Werte
              <tags-input ng-model="field.values" data-nodrag
                          display-property="name"
                          add-on-comma="false"
                          enableEditingLastTag="true"
                          min-length="1"
                          placeholder="Neuer Eintrag <Eingabetaste>"
                          replace-spaces-with-dashes="false"
                          template="tag-template">
              </tags-input>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</script>

<!-- Nested biopsy render template -->
<script type="text/ng-template" id="biopsy_renderer.html">
  <div ui-tree-handle class="tree-node tree-node-content">
    <div>
      <div class="row">
        <div class="col-md-10">
          {{vm.examtemplate.template.biopsy.label}}
          <div ng-class="{'hidden':ecollapsed}" ng-init="ecollapsed = true">
            <div class="form-group">
              <label>Feldname
                <input type="text" ng-model="vm.examtemplate.template.biopsy.label"
                       ng-blur="vm.examtemplate.$save().$save()" class="form-control"></label>
            </div>
            <div class="form-group">
              <label>Defaultwert(e)
                <tags-input ng-model="vm.examtemplate.template.biopsy.avalues"
                            display-property="name"
                            add-on-comma="false"
                            enableEditingLastTag="true"
                            placeholder="Neuer Eintrag <Eingabetaste>"
                            replace-spaces-with-dashes="false"
                            template="tag-template">
                </tags-input>
              </label>
            </div>
            <div class="form-group">
              <label>Mögliche Werte (mit Eingabetaste trennen)
                <tags-input ng-model="vm.examtemplate.template.biopsy.values"
                            display-property="name"
                            add-on-comma="false"
                            enableEditingLastTag="true"
                            placeholder="Neuer Eintrag <Eingabetaste>"
                            replace-spaces-with-dashes="false"
                            template="tag-template">
                </tags-input>
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <a class="pull-right btn btn-danger btn-xs" data-nodrag ng-click="vm.removeNamedField('biopsy')">
            <span class="fa fa-remove"></span>
          </a>
          <a class="pull-right btn btn-primary btn-xs" data-nodrag ng-click="ecollapsed=!ecollapsed"
             style="margin-right: 8px;">
            <span
                class="fa fa-edit"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</script>

<!-- Nested comment render template -->
<script type="text/ng-template" id="comment_renderer.html">
  <div ui-tree-handle class="tree-node tree-node-content">
    <div>
      <div class="row">
        <div class="col-md-10">
          {{vm.examtemplate.template.comment.label}}
          <div ng-class="{'hidden':ecollapsed}" ng-init="ecollapsed = true">
            <div class="form-group">
              <label>Feldname
                <input type="text" ng-model="vm.examtemplate.template.comment.label"
                       ng-blur="vm.examtemplate.$save().$save()" class="form-control"></label>
            </div>
            <div class="form-group">
              <label>Defaultwert(e)
                <tags-input ng-model="vm.examtemplate.template.comment.avalues"
                            display-property="name"
                            add-on-comma="false"
                            enableEditingLastTag="true"
                            placeholder="Neuer Eintrag <Eingabetaste>"
                            replace-spaces-with-dashes="false"
                            template="tag-template">
                </tags-input>
              </label>
            </div>
            <div class="form-group">
              <label>Mögliche Werte (mit Komma oder Eingabetaste trennen)
                <tags-input ng-model="vm.examtemplate.template.comment.values"
                            display-property="name"
                            add-on-comma="false"
                            enableEditingLastTag="true"
                            placeholder="Neuer Eintrag <Eingabetaste>"
                            replace-spaces-with-dashes="false"
                            template="tag-template">
                </tags-input>
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <a class="pull-right btn btn-danger btn-xs" data-nodrag ng-click="vm.removeNamedField('comment')">
            <span class="fa fa-remove"></span>
          </a>
          <a class="pull-right btn btn-primary btn-xs" data-nodrag ng-click="ecollapsed=!ecollapsed"
             style="margin-right: 8px;">
            <span
                class="fa fa-edit"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</script>

<!-- Nested diagnosis render template -->
<script type="text/ng-template" id="diagnosis_renderer.html">
  <div ui-tree-handle class="tree-node tree-node-content">
    <div>
      <div class="row">
        <div class="col-md-10">
          {{vm.examtemplate.template.diagnosis.label}}
          <div ng-class="{'hidden':ecollapsed}" ng-init="ecollapsed = true">
            <div class="form-group">
              <label>Feldname
                <input type="text" ng-model="vm.examtemplate.template.diagnosis.label"
                       ng-blur="vm.examtemplate.$save().$save()" class="form-control"></label>
            </div>
            <div class="form-group">
              <label>Defaultwert
                <tags-input ng-model="vm.examtemplate.template.diagnosis.avalues"
                            display-property="name"
                            add-on-comma="false"
                            enableEditingLastTag="true"
                            placeholder="Neuer Eintrag <Eingabetaste>"
                            replace-spaces-with-dashes="false"
                            template="tag-template">
                </tags-input>
              </label>
            </div>
            <div class="form-group">
              <label>Mögliche Werte (mit Komma oder Eingabetaste trennen)
                <tags-input ng-model="vm.examtemplate.template.diagnosis.values"
                            display-property="name"
                            add-on-comma="false"
                            enableEditingLastTag="true"
                            placeholder="Neuer Eintrag <Eingabetaste>"
                            replace-spaces-with-dashes="false"
                            template="tag-template">
                </tags-input>
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <a class="pull-right btn btn-danger btn-xs" data-nodrag ng-click="vm.removeNamedField('diagnosis')">
            <span class="fa fa-remove"></span>
          </a>
          <a class="pull-right btn btn-primary btn-xs" data-nodrag ng-click="ecollapsed=!ecollapsed"
             style="margin-right: 8px;">
            <span
                class="fa fa-edit"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</script>

<!-- Nested recommendation render template -->
<script type="text/ng-template" id="recommendation_renderer.html">
  <div ui-tree-handle class="tree-node tree-node-content">
    <div>
      <div class="row">
        <div class="col-md-10">
          {{vm.examtemplate.template.recommendation.label}}
          <div ng-class="{'hidden':ecollapsed}" ng-init="ecollapsed = true">
            <div class="form-group">
              <label>Feldname
                <input type="text" ng-model="vm.examtemplate.template.recommendation.label"
                       ng-blur="vm.examtemplate.$save().$save()" class="form-control"></label>
            </div>
            <div class="form-group">
              <label>Defaultwert(e)
                <tags-input ng-model="vm.examtemplate.template.recommendation.avalues"
                            display-property="name"
                            add-on-comma="false"
                            enableEditingLastTag="true"
                            placeholder="Neuer Eintrag <Eingabetaste>"
                            replace-spaces-with-dashes="false"
                            template="tag-template">
                </tags-input>
              </label>
            </div>
            <div class="form-group">
              <label>Mögliche Werte (mit Komma oder Eingabetaste trennen)
                <tags-input ng-model="vm.examtemplate.template.recommendation.values"
                            display-property="name"
                            add-on-comma="false"
                            enableEditingLastTag="true"
                            placeholder="Neuer Eintrag <Eingabetaste>"
                            replace-spaces-with-dashes="false"
                            template="tag-template">
                </tags-input>
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <a class="pull-right btn btn-danger btn-xs" data-nodrag
             ng-click="vm.removeNamedField('recommendation')">
            <span class="fa fa-remove"></span>
          </a>
          <a class="pull-right btn btn-primary btn-xs" data-nodrag ng-click="ecollapsed=!ecollapsed"
             style="margin-right: 8px;">
            <span
                class="fa fa-edit"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</script>


<!-- ngTagsInput tag formatting -->
<script type="text/ng-template" id="tag-template">
  <div class="tag-template">
    <div class="right-panel">
      <span>{{$getDisplayText()}}</span>
      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>
    </div>
  </div>
</script>
